import { type ReactNode } from 'react';
import { usePartnerAuthStore } from '@/stores/partnerAuthStore';

/**
 * Role gate for admin-only routes. Deliberately does NOT call fetchMe(): it is
 * always rendered inside ProtectedRoute, which has already re-verified the
 * partner against the server on mount. Calling fetchMe() here too would give
 * two components one shared isLoading flag and remount each other in a loop.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { partner } = usePartnerAuthStore();

  if (partner?.role !== 'admin') {
    // The testid is load-bearing, not decoration. Guarded pages render the
    // same denial copy from their own page-level guard, so a test asserting on
    // that string alone passes even with this component deleted from the
    // route. This marker is what proves the ROUTE gate ran.
    return (
      <div data-testid="require-admin-denied" className="flex h-64 items-center justify-center">
        <p className="text-sm text-muted-foreground">You do not have access to this page.</p>
      </div>
    );
  }

  return <>{children}</>;
}
